/* Shared MALIX footer boundary; preserves native menu transforms. */
(() => {
 if(window.MalixFooterBoundary){window.MalixFooterBoundary.refresh();return;}
 let current=null;
 function create(footer){
  const selector='.msn-panel,.malix-shop .ms-sidebar';
  const backdropSelector='.mep-menu-backdrop,.mab-menu-backdrop,.mlo-menu-backdrop,.mld-menu-backdrop,.mip-menu-backdrop,.mcp-menu-backdrop';
  let records=[],backdrops=[],frame=0,disposed=false;
  const resize=window.ResizeObserver?new ResizeObserver(schedule):null;
  function discover(){
    const previous=new Map(records.map(record=>[record.node,record]));
    records=Array.from(document.querySelectorAll(selector),node=>previous.get(node)||{node,y:0});
    backdrops=Array.from(document.querySelectorAll(backdropSelector));
    if(resize){resize.disconnect();resize.observe(footer);records.forEach(record=>resize.observe(record.node));}
    schedule();
  }
  function update(){
    frame=0;if(disposed || !footer.isConnected)return;
    const footerTop=footer.getClientRects().length?footer.getBoundingClientRect().top:Infinity;
    const bottom=footerTop-Math.min(2,Math.max(0,window.innerHeight-footerTop)),width=document.documentElement.clientWidth;
    // Read first and write once. There is no continuous animation or polling.
    const values=records.filter(record=>record.node.isConnected).map(record=>{
      const box=record.node.getBoundingClientRect();
      const desktop=box.width>0 && box.width<width-1;
      const baseBottom=box.bottom-record.y;
      return {record,desktop,y:desktop?Math.min(0,bottom-baseBottom):0};
    });
    const cuts=backdrops.filter(node=>node.isConnected).map(node=>{
      const box=node.getBoundingClientRect();
      const desktop=values.some(value=>value.desktop && value.record.node.parentElement===node.parentElement);
      return {node,desktop,cut:Math.max(0,Math.min(box.height,box.bottom-bottom))};
    });
    values.forEach(({record,desktop,y})=>{
      const value=y.toFixed(3)+'px';record.y=Number(y.toFixed(3));
      record.node.toggleAttribute('data-malix-footer-bound-menu',desktop);
      if(record.node.style.getPropertyValue('--malix-footer-menu-y')!==value)record.node.style.setProperty('--malix-footer-menu-y',value);
    });
    cuts.forEach(({node,desktop,cut})=>{node.toggleAttribute('data-malix-footer-bound-backdrop',desktop);const value=cut.toFixed(3)+'px';if(node.style.getPropertyValue('--malix-footer-backdrop-cut')!==value)node.style.setProperty('--malix-footer-backdrop-cut',value);});
  }
  function schedule(){if(!disposed && !frame)frame=requestAnimationFrame(update);}
  function changed(mutations){
    if(mutations.some(mutation=>Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(node=>node.nodeType===1 && (node.matches(selector+','+backdropSelector)||node.querySelector(selector+','+backdropSelector)))))discover();
  }
  const mutation=new MutationObserver(changed);mutation.observe(document.body,{childList:true,subtree:true});
  function sectionChanged(){discover();}
  function unloaded(event){if(event.target.contains(footer))destroy();else schedule();}
  function destroy(){
    if(disposed)return;disposed=true;cancelAnimationFrame(frame);mutation.disconnect();if(resize)resize.disconnect();
    window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);window.removeEventListener('pageshow',schedule);
    document.removeEventListener('shopify:section:load',sectionChanged);document.removeEventListener('shopify:section:unload',unloaded);
    records.forEach(({node})=>{node.removeAttribute('data-malix-footer-bound-menu');node.style.removeProperty('--malix-footer-menu-y');});
    backdrops.forEach(node=>{node.removeAttribute('data-malix-footer-bound-backdrop');node.style.removeProperty('--malix-footer-backdrop-cut');});
  
  }

  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});window.addEventListener('pageshow',schedule);
  document.addEventListener('shopify:section:load',sectionChanged);document.addEventListener('shopify:section:unload',unloaded);
  discover();if(document.fonts && document.fonts.ready)document.fonts.ready.then(schedule);

 return {footer,destroy,refresh:discover};
 }
 function refresh(){
  const footer=document.querySelector('.malix-footer[data-malix-footer-layout="split"]');
  if(current&&current.footer===footer){current.refresh();return;}
  if(current)current.destroy();current=footer?create(footer):null;
  window.malixFooterMenuBoundary=current;
 }
 if(window.malixFooterMenuBoundary)window.malixFooterMenuBoundary.destroy();
 window.MalixFooterBoundary={refresh,destroy(){if(current)current.destroy();current=null;document.removeEventListener('shopify:section:load',refresh);document.removeEventListener('shopify:section:unload',later);delete window.MalixFooterBoundary;}};
 function later(){requestAnimationFrame(refresh);}
 document.addEventListener('shopify:section:load',refresh);document.addEventListener('shopify:section:unload',later);
 refresh();
})();
